import DeleteWebhook from "./DeleteWebhook";
import TestWebhook from "./TestWebhook";
import WebhookForm from "./WebhookForm";

import type { WEBHOOKS_ACTIONS } from "../../constants";
import type { Webhook } from "../../types";

interface WebhookActionsProps {
  webhook: Webhook;
  action: keyof typeof WEBHOOKS_ACTIONS;
  onClose: () => void;
  onBack: () => void;
}

export default function WebhookActions({
  webhook,
  action,
  onClose,
  onBack,
}: WebhookActionsProps) {
  if (action === "edit") {
    return <WebhookForm webhook={webhook} onBack={onBack} />;
  }
  if (action === "test") {
    return (
      <TestWebhook
        webhookId={webhook.id}
        webhookEvents={webhook.events}
        onBack={onBack}
      />
    );
  }
  if (action === "delete") {
    return (
      <DeleteWebhook webhook={webhook} onBack={onBack} onClose={onClose} />
    );
  }
}
